module.exports = __webpack_public_path__ + "static/Shortfundly - Logo with slogan-ba0841be0d786063db2e98fee874fc11.jpg";